export default "__VITE_ASSET__d384c5fc__$_?react__"